import styled from "styled-components";

export const UploadPlaceholder = styled.div`
  width: 220px;
  height: 220px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  color: #bfbfbf;
  background: #fff;
  transition: border-color 0.2s, color 0.2s;

  span {
    font-size: 13px;
  }

  &:hover {
    border-color: #1677ff;
    color: #1677ff;
  }
`;

export const UploadPreview = styled.div`
  position: relative;
  width: 220px;
  height: 220px;
  border-radius: 8px;
  overflow: hidden;
`;

export const PreviewImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Overlay = styled.div<{ $visible: boolean }>`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const EditBtn = styled.span`
  .ant-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
    color: #fff !important;
  }
`;

export const DeleteBtn = styled.span`
  .ant-btn {
    background: rgba(255, 77, 79, 0.2) !important;
    border-color: #ff4d4f !important;
  }
`;